import { render } from "./CloseIcon.vue?vue&type=template&id=6acbedb3"
import script from "./CloseIcon.vue?vue&type=script&lang=js"
export * from "./CloseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__